import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import {store} from "./store/store";
import {PublicClientApplication} from "@azure/msal-browser";
import { BrowserRouter } from 'react-router-dom';
import './fonts/ChalkboardSE-Regular.ttf';

const pca =new PublicClientApplication({
  auth:{
    clientId:"97aa5394-1339-42c5-b03b-64f03440ff32",
    authority:"https://login.microsoftonline.com/organizations",
    redirectURi:"https://constemsai.com/tools"
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
})

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
  <Provider store={store}>
    <App  msalInstance={pca}/>
  </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
